<template>
  <div class="d-flex align-center pt-2">
    <Component
      :is="currentComponent"
      v-bind="currentProperties"
      v-model="internalValue"
    />
  </div>
</template>

<script>
  import TextInput from '@/components/ui/inputs/TextInput'
  import SelectInput from '@/components/ui/inputs/SelectInput'
  import SwitchInput from '@/components/ui/inputs/SwitchInput'
  import DatePicker from '@/components/ui/inputs/DatePicker'
  import MultiselectInput from '@/components/ui/inputs/MultiselectInput'

  import CommonMixin from '@/mixins/store/CommonMixin'

  export default {
    components: {
      TextInput,
      SelectInput,
      DatePicker,
      MultiselectInput,
      SwitchInput,
    },
    mixins: [CommonMixin,],
    props: {
      value: {
        type: [String, Number, Boolean, null,],
        default: null,
      },
      field: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        currentDate: new Date().toISOString().substr(0, 10),
        minDatePicked: '1900-01-01',
        textInputFields: [
          'last_name',
          'first_name',
          'birth_name',
          'other_names',
          'residence_permit_number',
          'reference_tax_number',
          'tax_address',
        ],
        selectInputFields: ['marital_status', 'matrimonial_regime', 'pacs_convention',],
        datePickerFields: ['date_of_birth',],
        multiSelectFields: [
          'birth_country',
          'birth_insee_code',
          'nationalities',
          'profession',
          'profession_sector',
          'tax_country',
        ],
        switchInputFields: ['civility',],
      }
    },
    computed: {
      internalValue: {
        get() {
          if (this.field === 'nationalities') {
            return this.value ? this.value.split(', ') : this.value
          }

          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      currentComponent() {
        if (this.selectInputFields.includes(this.field)) {
          return 'SelectInput'
        }
        if (this.datePickerFields.includes(this.field)) {
          return 'DatePicker'
        }
        if (this.multiSelectFields.includes(this.field)) {
          return 'MultiselectInput'
        }
        if (this.switchInputFields.includes(this.field)) {
          return 'SwitchInput'
        }

        return 'TextInput'
      },
      currentProperties() {
        if (this.selectInputFields.includes(this.field)) {
          let options = {}
          switch (this.field) {
          case 'marital_status':
            options = this.enumsOptions.maritalStatus
            break
          case 'matrimonial_regime':
            options = this.enumsOptions.matrimonialRegime
            break
          case 'pacs_convention':
            options = this.enumsOptions.pacsConvention
            break
          }

          return {
            options,
            default: this.internalValue,
            'item-text': 'label',
            'item-value': 'code',
            hideDetails: true,
          }
        }
        if (this.multiSelectFields.includes(this.field)) {
          let options = {}
          switch (this.field) {
          case 'birth_insee_code':
            options = this.enumsOptions.cities
            break
          case 'profession':
            options = this.enumsOptions.profession
            break
          case 'profession_sector':
            options = this.enumsOptions.professionSector
            break
          default:
            options = this.enumsOptions.countries
            break
          }

          return {
            options,
            'item-text': 'label',
            'item-value': 'code',
            hideDetails: true,
            default: this.internalValue,
            multiple: this.field === 'nationalities',
          }
        }
        if (this.datePickerFields.includes(this.field)) {
          return {
            min: this.minDatePicked,
            max: this.currentDate,
            default: this.internalValue,
            datePickedProp: this.internalValue,
            hideDetails: true,
          }
        }
        if (this.switchInputFields.includes(this.field)) {
          return {
            options: this.enumsOptions.civilities,
          }
        }

        return {
          hideDetails: true,
        }
      },
    },
  }
</script>
